import React from 'react';

import Head from 'next/head';

import Footer from '@/components/Footer';
import Header from '@/components/Header';
import CountryHero from '@/components/CountryHero';
import StatesList from '@/components/StatesList';

const Us = () => {
  return (
    <div className="page-wrapper">
      <Head>
        <title>United States Directory for Home Service Pros Near You | CallAPro</title>
        <meta name="description" content="CallAPro - Find a Home Service Professional Near You" />

        <link rel="canonical" href="https://www.callapro.com/us/" />
      </Head>
      <Header />
      <CountryHero />
      <StatesList />
      <Footer />
    </div>
  );
};

export default Us;
